namespace app.support {
    'use strict';
    
    angular.module('app.support', [
        'app.core',
        'app.support.authorization',
        'app.support.messaging',
        'app.support.command',
        'app.support.constants',
        'app.support.suggestion',
        'app.support.websocket',
        'app.support.identidades',
        'app.support.alert'
    ]);
}